import React, { useState } from "react";
import { Box, Typography, Dialog, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import * as routes from "../../../constants/routes";
import personMore from "../../../assets/images/SVG/personMore.svg";
import setting from "../../../assets/images/SVG/setting.svg";
import ProfileUpadateModal from "../../ProfileUpdateModal";
import { useProfileUpdate } from "../../../hooks/useProfileUpdate";

const AcessAdjustModal = ({ open, onClose }) => {
    const navigate = useNavigate();
    const { updateProfile, currentProfile } = useProfileUpdate();
    const [profileModalOpen, setProfileModalOpen] = useState(false);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle sx={{ textAlign: "center", fontWeight: 600, fontSize: "24px", color: "#662D91" }}>
                Ajustar acesso
                <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: "16px",
                    padding: "16px 24px 32px",
                }}
            >
                <Box
                    onClick={() => { navigate(routes.R_RESCUE_CODE); onClose(); }}
                    sx={{
                        flex: 1,
                        border: "1px solid #E0E0E0",
                        borderRadius: "12px",
                        padding: "20px",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#F9F5FF" },
                    }}
                >
                    <Box sx={{ width: "60px", height: "60px", mb: 1 }}>
                        <img src={personMore} alt="Usuarios" width="100%" height="100%" />
                    </Box>
                    <Typography fontWeight={600} fontSize="16px" mb={1}>
                        Conectar via código ou link convite
                    </Typography>
                    <Typography fontSize="15px" color="text.secondary">
                        Peça a um profissional ou responsável um código ou link de convite para se conectar
                    </Typography>
                </Box>
                <Box
                    onClick={() => { setProfileModalOpen(true); }}
                    sx={{
                        flex: 1,
                        border: "1px solid #E0E0E0",
                        borderRadius: "12px",
                        padding: "20px",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#F9F5FF" }
                    }}
                >
                    <Box sx={{ width: "60px", height: "60px", mb: 1 }}>
                        <img src={setting} alt="configurações" width="100%" height="100%" />
                    </Box>
                    <Typography fontWeight={600} fontSize="16px" mb={1} >
                        Não é paciente?
                    </Typography>
                    <Typography fontSize="15px" color="text.secondary">
                        Confirme seu perfil para usar a plataforma com a experiência mais alinhada a você
                    </Typography>
                </Box>
            </Box>
            <ProfileUpadateModal
                open={profileModalOpen}
                onClose={() => setProfileModalOpen(false)}
                currentProfile={currentProfile}
                onProfileUpdate={updateProfile}
            />
        </Dialog>
    )
}

export default AcessAdjustModal;
